import { IconBrandAppleFilled, IconBrandAndroid, IconCircleCheckFilled } from "@tabler/icons-react"
import { useTranslation } from "react-i18next"

const Platforms = () => {
  const { t } = useTranslation()

  return (
    <section className="py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h2 className="text-3xl md:text-4xl font-semibold text-slate-900 mb-6">
            {t("platforms.title")}
          </h2>
          <p className="text-base md:text-lg text-slate-600 max-w-2xl mx-auto px-8 md:px-0">
            {t("platforms.androidWaitlist")}
            <a href="https://docs.google.com/forms/d/e/1FAIpQLSf4Ij9NDDdPmbOdK9Hn09U31plO0drOyF14SOFfb0_YJRFm9Q/viewform" className="text-sky-500">
              {t("platforms.androidWaitlistLink")}
            </a>
            {t("platforms.androidWaitlistSuffix")}
          </p>
        </div>

        <div className="flex items-center gap-4 mb-8 bg-slate-100 py-8 md:py-12 px-6 rounded-xl">
          <div className="flex flex-col items-center gap-4 flex-1">
            <IconBrandAppleFilled className="w-12 h-12 text-slate-700" />
            <div className="flex items-center gap-2">
              <IconCircleCheckFilled className="w-5 h-5 text-green-500" />
              <span className="text-slate-700 font-semibold">{t("platforms.status.iphone")}</span>
            </div>
          </div>
          <div className="w-[1px] bg-slate-200 h-24 mx-1"></div>
          <div className="flex flex-col items-center gap-4 flex-1">
            <IconBrandAndroid className="w-12 h-12 text-slate-300" />
            <div className="flex items-center gap-2">
              <span className="text-slate-300 text-center text-sm md:text-base">{t("platforms.status.android")}</span>
            </div>
          </div>
        </div>

      </div>
    </section>
  )
}

export default Platforms